import React from 'react';
import styles from './FormField.module.scss';

interface PortalFieldProps {
  label: string;
  hint?: string;
  error?: string;
  showError?: boolean;
  fullWidth?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export function PortalField({
  label,
  hint,
  error,
  showError,
  fullWidth,
  className,
  style,
  children,
}: PortalFieldProps) {
  return (
    <div className={`${styles.portalField} ${fullWidth ? styles.fullWidth : ''} ${className ?? ''}`} style={style}>
      <div className={styles.portalLabel}>{label}</div>
      {children}
      {hint && <div className={styles.fieldHint}>{hint}</div>}
      {error && <div className={`${styles.fieldError} ${showError ? styles.fieldErrorVisible : ''}`}>{error}</div>}
    </div>
  );
}
